$bog_vmap_app_scenes $mol_page
	store $bog_vmap_app_store
	current? \
	doc_title? \
	current_exists false
	title \Сцены
	tools /
		<= Name $mol_string
			hint \Название сцены
			enabled <= current_exists
			value? <=> doc_title?
		<= Add $mol_button_minor
			hint \Новая сцена: завести документ, он станет текущим
			click? <=> add? null
			sub /
				<= Add_icon $mol_icon_plus
	face_brief \
	face_note \
	face_who \
	face_file \blob.bin
	face_draft? \
	face_take? null
	face_status \
	body /
		<= List $mol_list
			rows <= scene_rows /
	foot /
		<= Face_brief $mol_paragraph
			title <= face_brief \
		<= Face $mol_expander
			title \Личность
			expanded? <=> face_shown? false
			content /
				<= Face_note $mol_paragraph
					title <= face_note
				<= Face_who $mol_paragraph
					title <= face_who
				<= Face_save $mol_button_download
					title \Сохранить ключ в файл
					hint \Скачать строку личности файлом. Это ключ: у кого он есть, тот и есть вы
					blob <= face_blob $mol_blob
					file_name <= face_file
				<= Face_field $mol_string
					hint \Строка ключа или ссылка с ним
					value? <=> face_draft?
				<= Face_take $mol_button_minor
					title \Перенести личность сюда
					hint \Принять сохранённую личность и перезагрузить редактор
					click? <=> face_take?
				<= Face_status $mol_status
					status <= face_status
	Menu $bog_vmap_app_menu
		showed? <=> menu_showed? false
		left <= menu_left \
		top <= menu_top \
		items <= menu_items /$mol_view
		close? <=> menu_close? null
	Scene_row* $bog_vmap_app_palette_item
		title <= scene_title* \
		hint <= scene_title* \
		current <= scene_current* false
		click? <=> scene_click*? null
		event *
			^
			contextmenu? <=> scene_menu*? null
	Drop $bog_vmap_app_menu_item
		title \Удалить сцену
		act? <=> drop_ask? null
	Drop_note $mol_paragraph
		title <= drop_note \
	Drop_yes $bog_vmap_app_menu_item
		title \Удалить
		act? <=> drop? null
		done? <=> menu_close?
	Drop_no $bog_vmap_app_menu_item
		title \Отмена
		act? <=> menu_close?
